import { render, staticRenderFns } from "./ExtentionDetailSummary.vue?vue&type=template&id=4e5e0a3e"
import script from "./ExtentionDetailSummary.vue?vue&type=script&lang=js"
export * from "./ExtentionDetailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports